import NiceSelect2 from "nice-select2";
import { lenis } from '../utils/ScrollLenis';

const NiceSelect = NiceSelect2.default || NiceSelect2;

export default class NiceSelectInit {
    constructor(selector = '.js-select') {
        this.selector = selector;
        this.init();
    }

    init() {
        const elements = document.querySelectorAll(this.selector);

        if (elements.length === 0) return;

        elements.forEach((select) => {
            if (select.classList.contains('nice-select-initialized')) return;

            if (select.niceSelectInstance) {
                select.niceSelectInstance.destroy();
            }

            const niceSelectInstance = new NiceSelect(select, {
                searchable: false
            });

            select.niceSelectInstance = niceSelectInstance;
            select.classList.add('nice-select-initialized');

            this.handleLenisFixes(select);
        });
    }

    handleLenisFixes(select) {
        const dropdown = select.parentElement.querySelector('.nice-select');
        if (!dropdown) return;

        dropdown.setAttribute('data-lenis-prevent', '');
        dropdown.addEventListener('mousedown', () => {
            lenis?.stop();
        });
        document.addEventListener('mouseup', () => {
            lenis?.start();
        });

        select.addEventListener('click', () => {
            requestAnimationFrame(() => {
                lenis?.raf(performance.now());
            });
        });
    }
}
